// ----------------------------------------------------------------------

export default function Snackbar(containerId: string) {
  return {
    MuiSnackbarContent: {
      defaultProps: {
        container: document.getElementById(containerId),
      },
      styleOverrides: {
        root: {},
      },
    },
  };
}
